<template>
  <main-template>
    <v-container>
      <v-row>
        <v-col cols="12" class="d-flex align-center">
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          <span class="text-h6 ml-2">Confirmação</span>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" sm="8" md="6">
          <!-- Seção Resumo -->
          <v-card outlined rounded="lg" class="mb-4">
            <v-card-title class="text-subtitle-1 font-weight-bold pb-1">Resumo</v-card-title>
            <v-divider />
            <v-card-text>
              <!-- Valor total + Vencimento -->
              <v-row no-gutters class="mb-4">
                <v-col cols="6">
                  <div class="text-caption grey--text">Valor total</div>
                  <v-skeleton-loader v-if="carregandoResumo" type="text" width="80" class="mt-1" />
                  <!-- converter para moeda -->
                  <div
                    v-else
                    class="text-body-1 font-weight-bold"
                    :class="
                      dadosBoleto.emitido_apos_vencimento
                        ? 'text-body-2 grey--text text-decoration-line-through'
                        : 'text-body-2 font-weight-bold'
                    "
                  >
                    {{ dadosParcela.valor | currency }}
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="text-caption grey--text">Vencimento</div>
                  <v-skeleton-loader v-if="carregandoResumo" type="text" width="80" class="mt-1" />
                  <div
                    v-else
                    class="text-body-1 font-weight-bold"
                    :class="
                      dadosBoleto.emitido_apos_vencimento
                        ? 'text-body-2 grey--text text-decoration-line-through'
                        : 'text-body-2 font-weight-bold'
                    "
                  >
                    <span v-if="dadosParcela.vencimento">
                      {{
                        dadosParcela.vencimento | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY")
                      }}
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mb-4" v-if="dadosBoleto.emitido_apos_vencimento">
                <v-col cols="6">
                  <div class="text-caption grey--text">Valor total com Juros</div>
                  <v-skeleton-loader v-if="carregandoResumo" type="text" width="80" class="mt-1" />
                  <!-- converter para moeda -->
                  <div v-else class="text-body-1 font-weight-bold">
                    {{ dadosBoleto.valor | currency }}
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="text-caption grey--text">Vencimento</div>
                  <v-skeleton-loader v-if="carregandoResumo" type="text" width="80" class="mt-1" />
                  <div v-else class="text-body-1 font-weight-bold">
                    <span v-if="dadosBoleto.vencimento">
                      {{
                        dadosBoleto.vencimento | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY")
                      }}
                    </span>
                  </div>
                </v-col>
              </v-row>

              <!-- Responsável -->
              <!-- <div class="mb-4">
                <div class="text-caption grey--text">Responsável</div>
                <div class="text-body-2 font-weight-medium">{{ nomeResponsavel }}</div>
                <div v-if="cpfResponsavel" class="text-caption grey--text">
                  CPF/CNPJ: {{ cpfResponsavel }}
                </div>
              </div> -->

              <!-- Alunos + Identificação -->
              <!-- <v-row no-gutters>
                <v-col cols="6">
                  <div class="text-caption grey--text">Aluno(a)</div>
                  <div v-for="aluno in alunosUnicos" :key="aluno" class="text-body-2">
                    {{ aluno }}
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="text-caption grey--text">Identificação da fatura</div>
                  <div class="text-caption" style="word-break: break-all">
                    {{ identificacaoFatura }}
                  </div>
                  <div class="text-caption grey--text mt-2">Data de emissão</div>
                  <div class="text-caption">{{ dataEmissao }}</div>
                </v-col>
              </v-row> -->
            </v-card-text>
          </v-card>

          <!-- Seção Detalhes da fatura -->
          <v-card outlined rounded="lg" class="mb-4">
            <v-card-title class="text-subtitle-1 font-weight-bold pb-1">
              Detalhes da mensalidade
            </v-card-title>
            <v-divider />
            <v-card-text class="pb-1">
              <!-- Escola (valor fixo) -->
              <div class="text-body-2 font-weight-medium">COLEGIO LOGOS</div>
              <div class="text-caption grey--text mb-3">CNPJ: 05.430.230/0001-04</div>
              <!-- Cabeçalho colunas -->
              <v-row no-gutters class="text-caption grey--text">
                <!-- <v-col>Descrição</v-col> -->
                <!-- <v-col cols="auto">Valor</v-col> -->
              </v-row>
            </v-card-text>
            <v-divider />
            <v-list dense>
              <!-- <v-list-item v-for="parcela in parcelasSelecionadas" :key="parcela.id">
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">
                    {{ parcela.descricaoMensalidade }}
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="parcela.aluno" class="text-caption">
                    {{ parcela.aluno.nomecompleto }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-caption">
                    Ref.
                    {{ parcela.referencia | dateParse("YYYY-MM-DD") | dateFormat("MM/YYYY") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <span class="text-body-2">{{ parcela.valorEmAberto | currency }}</span>
              </v-list-item> -->

              <v-divider />

              <!-- <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">Subtotal</v-list-item-title>
                </v-list-item-content>
                <span class="text-body-2">{{ subtotal | currency }}</span>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">Desconto</v-list-item-title>
                </v-list-item-content>
                <span class="text-body-2 success--text">{{ totalDesconto | currency }}</span>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">Multa/Juros</v-list-item-title>
                </v-list-item-content>
                <span class="text-body-2">{{ (totalMulta + totalJuros) | currency }}</span>
              </v-list-item> -->

              <v-divider />

              <!-- Faixas de desconto -->
              <template v-if="parcela && parcela.descontosTiers.length > 0">
                <v-list-item v-for="(tier, i) in parcela.descontosTiers" :key="i">
                  <v-list-item-content>
                    <v-list-item-title
                      :class="
                        tierExpirado(tier)
                          ? 'text-body-2 grey--text text-decoration-line-through'
                          : tier.valor == parcela.descontoAplicavel
                          ? 'text-body-2 font-weight-bold'
                          : 'text-body-2 grey--text'
                      "
                    >
                      Desconto de pontualidade
                    </v-list-item-title>
                    <v-list-item-subtitle
                      :class="
                        tierExpirado(tier)
                          ? 'text-caption grey--text text-decoration-line-through'
                          : 'text-caption'
                      "
                    >
                      Válido até
                      {{ tier.data | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <span
                    :class="
                      tierExpirado(tier)
                        ? 'text-body-2 grey--text text-decoration-line-through'
                        : tier.valor == parcela.descontoAplicavel
                        ? 'text-body-2 success--text font-weight-bold'
                        : 'text-body-2 grey--text'
                    "
                  >
                    - {{ tier.valor | currency }}
                  </span>
                </v-list-item>
                <v-divider />
              </template>

              <!-- Multa e juros (parcela atrasada) -->
              <template v-if="parcela && parcela.estaAtrasada">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2 error--text">Multa</v-list-item-title>
                  </v-list-item-content>
                  <span class="text-body-2 error--text"
                    >+ {{ parcela.multaCalculada | currency }}</span
                  >
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2 error--text"
                      >Juros mora</v-list-item-title
                    >
                    <v-list-item-subtitle class="text-caption error--text">
                      {{ parcela.diasAtraso }} {{ parcela.diasAtraso === 1 ? "dia" : "dias" }} em
                      atraso
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <span class="text-body-2 error--text"
                    >+ {{ parcela.jurosCalculados | currency }}</span
                  >
                </v-list-item>
                <v-divider />
              </template>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-subtitle-2 font-weight-bold">
                    Total
                  </v-list-item-title>
                </v-list-item-content>
                <span class="text-subtitle-2 font-weight-bold primary--text">
                  {{ dadosBoleto.valorEmAberto | currency }}
                </span>
              </v-list-item>
            </v-list>

            <!-- Notas de vencimento -->
            <v-card-text class="pt-1 text-caption grey--text">
              <!-- <div>Após o vencimento, cobrar multa de 2% e juros de 1% ao mês.</div> -->
              <div>Não receber após 30 dias do vencimento.</div>
              <!-- <div
                v-for="(tier, ti) in (parcelasSelecionadas[0] &&
                  parcelasSelecionadas[0].descontosTiers) ||
                []"
                :key="`desc-${ti}`"
              >
                Desconto de {{ tier.valor | currency }} até
                {{ tier.data | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }}.
              </div> -->
            </v-card-text>
          </v-card>

          <!-- Seção Pix -->
          <v-card v-if="formaPagamento === 'boleto_pix'" outlined rounded="lg" class="mb-4">
            <v-card-title class="text-subtitle-1 font-weight-bold pb-1">Pix</v-card-title>
            <v-divider />
            <v-card-text class="text-center">
              <img
                v-if="qrCodeDataUrl"
                :src="qrCodeDataUrl"
                alt="QR Code Pix"
                style="width: 200px; height: 200px"
              />
              <v-icon v-else size="96" color="grey lighten-1">mdi-qrcode</v-icon>
              <v-btn
                color="primary"
                block
                class="mt-4"
                @click="copiarPix"
                :disabled="!dadosBoleto.qrCode"
              >
                <v-icon left>mdi-content-copy</v-icon>
                Copiar código Pix
              </v-btn>
            </v-card-text>
          </v-card>

          <!-- Seção Boleto -->
          <v-card v-if="formaPagamento === 'boleto_pix'" outlined rounded="lg" class="mb-6">
            <v-card-title class="text-subtitle-1 font-weight-bold pb-1">Boleto</v-card-title>
            <v-divider />
            <v-card-text class="text-center">
              <!-- <v-icon size="64" color="grey lighten-1">mdi-barcode</v-icon> -->
              <div class="text-caption grey--text mt-2">
                {{ dadosBoleto.linhaDigitavel }}
              </div>
              <v-btn
                outlined
                block
                class="mt-4"
                @click="copiarBoleto"
                :disabled="parcela.boleto === 0"
              >
                <v-icon left>mdi-content-copy</v-icon>
                Copiar código de barras
              </v-btn>
              <v-btn
                outlined
                block
                class="mt-2"
                :loading="carregandoBoleto"
                @click="baixarPdf"
                :disabled="parcela.boleto === 0"
              >
                <v-icon left>mdi-file-pdf-box</v-icon>
                Baixar PDF do boleto
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Snackbar stub -->
    <v-snackbar v-model="snackbar" timeout="3000" top>
      {{ snackbarMensagem }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MensalidadeConfirmacao",

  computed: {
    ...mapGetters("Mensalidades", ["matriculaSelecionada", "formaPagamento"]),

    nomeResponsavel() {
      return this.matriculaSelecionada?.aluno?.responsavel?.descricao || "—";
    },

    // cpfResponsavel() {
    //   const cpf = this.matriculaSelecionada?.aluno?.responsavel?.cpf;
    //   if (!cpf) return "";
    //   const limpo = cpf.replace(/\D/g, "");
    //   if (limpo.length !== 11) return cpf;
    //   return `***.${limpo.slice(3, 6)}.${limpo.slice(6, 9)}-**`;
    // },

    // identificacaoFatura() {
    //   // a parcela selecionada deve ser a parcela_id que vem no parametro
    //   return (this.parcela = this.$route.params.parcelaId
    //     ? this.parcelasSelecionadas.find((p) => p.id === parseInt(this.$route.params.parcelaId))
    //         ?.identificacaoFatura
    //     : this.parcelasSelecionadas[0]?.identificacaoFatura || "—");
    // },

    dataEmissao() {
      const hoje = new Date();
      const dia = String(hoje.getDate()).padStart(2, "0");
      const mes = String(hoje.getMonth() + 1).padStart(2, "0");
      return `${dia}/${mes}/${hoje.getFullYear()}`;
    },

    alunosUnicos() {
      const nomes = this.parcelasSelecionadas.map((p) => p.aluno?.nomecompleto).filter(Boolean);
      return [...new Set(nomes)];
    },

    subtotal() {
      if (!this.parcela) return 0;
      return this.parcela.valor;
    },

    totalDesconto() {
      if (!this.parcela) return 0;
      return this.parcela.descontoAplicavel || 0;
    },

    totalMulta() {
      if (!this.parcela) return 0;
      return this.parcela.multa || 0;
    },

    totalJuros() {
      if (!this.parcela) return 0;
      return this.parcela.juros || 0;
    },

    totalGeral() {
      if (!this.parcela) return 0;
      return this.parcela.valor || 0;
    },
  },

  data() {
    return {
      parcela: null,
      carregandoResumo: true,
      carregandoBoleto: false,
      snackbar: false,
      snackbarMensagem: "",
      qrCodeDataUrl: null,
      dadosBoleto: {
        linhaDigitavel: "null",
        emitido_apos_vencimento: false,
        valor: 0,
        vencimento: "",
        multa: 0,
        juros: 0,
        qrCode: "",
      },
      dadosParcela: {
        valor: 0,
        vencimento: "",
      },
    };
  },

  parcelaId() {
    return this.$route.params.parcelaId;
  },

  mounted() {
    this.verificarBoleto();
    this.getParcela();
  },

  methods: {
    async getParcela() {
      try {
        this.parcela = await this.$services.parcelasService.getParcela(
          this.$route.params.parcelaId
        );
      } catch (error) {
        this.$handleError(error);
      }
    },

    async verificarBoleto() {
      this.carregandoResumo = true;
      this.$loaderService.open("Verificando boleto");
      try {
        const dadosBoleto = await this.$services.boletosService.verificarBoleto(
          this.$route.params.parcelaId
        );
        this.dadosBoleto = dadosBoleto.boleto;
        this.dadosParcela = dadosBoleto.parcela;
        if (dadosBoleto.boleto.qrCode) {
          this.gerarQrCode(dadosBoleto.boleto.qrCode);
        }
      } catch (error) {
        const dados = error?.response?.data;
        const sufixo = "Entre em contato com a coordenação escolar.";
        if (dados?.erro && Array.isArray(dados?.mensagens)) {
          const msgs = dados.mensagens.map((m) => m.mensagem).join(" ");
          this.$toast.danger(`${msgs} ${sufixo}`);
        } else {
          this.$toast.danger(`Erro ao verificar boleto. ${sufixo}`);
        }
      } finally {
        this.$loaderService.close();
        this.carregandoResumo = false;
      }
    },
    exibirSnackbar(mensagem) {
      this.snackbarMensagem = mensagem;
      this.snackbar = true;
    },

    tierExpirado(tier) {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      return new Date(`${tier.data}T23:59:59`) < hoje;
    },

    async gerarQrCode(conteudo) {
      const QRCode = await import("qrcode");
      this.qrCodeDataUrl = await QRCode.toDataURL(conteudo, { width: 200, margin: 1 });
    },

    copiarPix() {
      if (this.dadosBoleto.qrCode) {
        navigator.clipboard.writeText(this.dadosBoleto.qrCode);
        this.exibirSnackbar("Código Pix copiado para área de transferência");
      }
    },

    copiarBoleto() {
      navigator.clipboard.writeText(this.dadosBoleto.linhaDigitavel);
      this.exibirSnackbar("Código de barras copiado para área de transferência");
    },

    async baixarPdf() {
      this.carregandoBoleto = true;
      try {
        await this.$services.relatoriosService.baixarBoletoParcela(this.$route.params.parcelaId);
      } catch (error) {
        console.log(error.error);

        this.$handleError(error);
      } finally {
        this.carregandoBoleto = false;
      }
    },
  },
};
</script>
